import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        
      
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card" title="Go to The project"> 
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="SwappCee"
              description="Développement d'un portail de traitement des processus de
              collecte, de contrôle et de dépôt de dossiers CEE (certificat
              d'économie d'énergie) pour le secteur résidentiel et tertiaire
              d'Engie"
              demoLink="https://swappcee.engie.fr/"
              stack = "Symfony, Drupal, PHP, PHPUnit, JavaScript, Docker, Agile Scrum"
              
            />
          </Col>

          <Col md={4} className="project-card" title="Go to The project"> 
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="HDM Network"
              description="Développement d'une application qui permet de gérer les employés et les offres de recrutement de l'entreprise HDM Network"
              demoLink="https://www.hdmnetwork.com/fr"
              stack = "Symfony, React JS, Docker"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="OllCargo"
              description="Développement d'un système d'aide à la planification et de suivi
              en temps réel de livraisons de commandes pour une plateforme
              de vente en ligne de produits alimentaires «Ollca»,"
              ghLink=""
              demoLink="https://www.ollca.com/"
              stack = "Spring Boot, Angular, Kafka, Mockito, CI/CD, Agile Scrum"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="SYSTÈME DE GESTION DE BOUTIQUES"
              description="Développement d'un système qui permet la gestion de
              boutiques de produits et de catégories associées aux produits"
              demoLink="https://github.com/hichemCodes/ProjetFullStack"   
              stack = "Symfony, React JS, Docker"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="DÉVELOPPEMENT D'UN GÉNÉRATEUR DE BLOGS"
              description="Développement d'une application permettant de générer des
              blogs avec des interactions (likes et des commentaires) pour les
              utilisateurs authentifiés"
              demoLink="https://github.com/hichemCodes/Blogger"
              stack = ".Net, jQuery"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="DÉVELOPPEMENT D'UN GESTIONNAIRE DES NOTES D'ÉTUDIANTS"
              description="Développement d'un module de gestion des notes dans un
              gestionnaire d'établissement universitaire."
              demoLink="https://github.com/hichemCodes/Gestion-des-notes"
              stack = "Node JS, React JS, Agile Scrum"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
